import { LoaderFunctionArgs } from "react-router-dom";
import { Api         } from "../api/Api";
import { AerialImage, ObbAnnotation, DatasetImage } from "../api/Application";
import { optionalParamIds, paramIds } from "../api/ApiUtil";

export interface ImageListLoaderData {
    images: AerialImage[];
    error?: string;
}

export type DatasetImageLoaderData = [DatasetImage, ObbAnnotation[], AerialImage | undefined];

export async function datasetImageLoader( { params, request }: LoaderFunctionArgs ): Promise<DatasetImageLoaderData> {
    const { datasetId, datasetImageId } = paramIds( params );
    const get = await Api.datasetImageGet( datasetImageId );
    if( !get.isOk ) {
        throw new Error( "Couldn't load DatasetImage" );
    }
    const lst = await Api.datasetImageObjectList( datasetImageId );
    if( !lst.isOk ) {
        throw new Error( "Couldn't load Annotations" );
    }
    const url = new URL( request.url );
    const aerialImageIdStr = url.searchParams.get( "aerialImageId" );
    if( !aerialImageIdStr ) {
        return [get.value, lst.value, undefined]
    }
    const aerialImage = await Api.aerialImageGet( Number( aerialImageIdStr ) );
    if( aerialImage.isOk ) {
        return [get.value, lst.value, aerialImage.value];
    }
    throw new Error( "Couldn't load DatasetImage" );
}